// «Liquidações» — todas as entidades e serviços, e os estafetas (backend: /v1/admin/liquidacoes)
import api from './api';

export interface TotaisPendentes {
  n: number; bruto: number; comissao: number; iva: number; entrega: number; sisp: number; liquido: number; estimadas: number;
}

export interface LinhaResumo {
  entidadeId: string;
  entidade: string;
  entidadeSisp: boolean;
  servico: string;
  servicoNome: string;
  remuneracao: 'ENTIDADE' | 'SISP';
  /** LIGADA = valores calculados; EVENTOS = separador Eventos; SISP = sem comissão; POR_LIGAR = ainda sem fonte */
  fonte: 'LIGADA' | 'EVENTOS' | 'SISP' | 'POR_LIGAR';
  pendente?: TotaisPendentes;
  ultimaLiquidacao: string | null;
  emAberto: number;
  /** Há transacções por liquidar mas a entidade não tem contrato neste serviço (comissão por omissão). */
  semContrato?: boolean;
}

export interface LiquidacaoGeral {
  id: string; entidade_id: string; servico: string; periodo_inicio: string | null; periodo_fim: string;
  estado: 'RASCUNHO' | 'APROVADA' | 'PAGA' | 'ANULADA'; n_transacoes: number;
  bruto_cve: string; comissao_cve: string; comissao_iva_cve: string; entrega_cve: string; sisp_cve: string;
  sisp_estimadas: number; liquido_cve: string; criado_em: string; aprovado_em: string | null; pago_em: string | null;
  referencia_banco: string | null;
}

export interface EstafetaPendente {
  motoboyId: string; nome: string; telefone: string | null; n: number; valor: number;
  entregas: Array<{ entregaId: number; pedidoId: number; restaurante: string; entregueEm: string; valor: number }>;
}

export interface LiquidacaoEstafeta {
  id: string; motoboy_id: string; nome: string | null; periodo_fim: string; n_entregas: number; valor_cve: string;
  estado: 'RASCUNHO' | 'PAGA' | 'ANULADA'; criado_em: string; pago_em: string | null; referencia_banco: string | null;
}

const base = '/admin/liquidacoes';

export const liquidacoesGerais = {
  async resumo(ate?: string): Promise<LinhaResumo[]> {
    const { data } = await api.get(`${base}/resumo`, { params: { ate } });
    return data.data || [];
  },
  async gerar(entidadeId: string, servico: string, ate: string) {
    const { data } = await api.post(`${base}/gerar`, { entidadeId, servico, ate });
    return data.data;
  },
  async listar(f: { entidadeId?: string; servico?: string; estado?: string } = {}): Promise<LiquidacaoGeral[]> {
    const { data } = await api.get(base, { params: f });
    return data.data || [];
  },
  async linhas(id: string) {
    const { data } = await api.get(`${base}/${id}/linhas`);
    return data.data || [];
  },
  async mudarEstado(id: string, accao: 'APROVAR' | 'PAGAR' | 'ANULAR', referencia?: string) {
    await api.patch(`${base}/${id}`, { accao, referencia });
  },
  async estafetasPendentes(ate?: string): Promise<EstafetaPendente[]> {
    const { data } = await api.get(`${base}/estafetas/pendentes`, { params: { ate } });
    return data.data || [];
  },
  async gerarEstafetas(ate: string, motoboyId?: string) {
    const { data } = await api.post(`${base}/estafetas`, { ate, motoboyId });
    return data.data || [];
  },
  async listarEstafetas(): Promise<LiquidacaoEstafeta[]> {
    const { data } = await api.get(`${base}/estafetas`);
    return data.data || [];
  },
  async mudarEstadoEstafeta(id: string, accao: 'PAGAR' | 'ANULAR', referencia?: string) {
    await api.patch(`${base}/estafetas/${id}`, { accao, referencia });
  },
};
